module.exports = __webpack_public_path__ + "static/media/right-chevrolet.024bd706.svg";